/**
 * Client-safe formatting for a live Stripe Nova price. The price is fetched
 * server-side (`fetchNovaPrice`) but rendered in the paywall, trial banner, and
 * billing page, so the formatter lives in shared code with a structural input
 * type (no server-only imports).
 *
 * Aliases: format nova price, nova price label
 */

import { formatStripeAmount } from "~/lib/shared/currency";

/** Structural shape of a resolved Stripe recurring price. */
export type FormattableNovaPrice = {
  amountCents: number;
  currency: string;
  interval: string;
};

/** e.g. "$125.00/month". The divisor comes from the currency — a zero-decimal
 *  one like JPY is already in whole units. */
export function formatNovaPrice(price: FormattableNovaPrice): string {
  return `${formatStripeAmount(price.amountCents, price.currency)}/${price.interval}`;
}
